/**
 * values for setting the 'scope' in opt in and 'profile' in multi optin
 */
import { locale } from './../../ModuleEditor/util/locale-wrapper';

const OPT_IN_SCOPE = {
  BRAND:       'brand',
  GROUP:       'group',
  THIRD_PARTY: 'third_party',
};

const OPT_IN_SCOPE_ALL = _.values(OPT_IN_SCOPE, 'value');

const OPT_IN_SCOPE_LIST = [
  { text: locale('Brand'), value: OPT_IN_SCOPE.BRAND, description: '' },
  { text: locale('Group'), value: OPT_IN_SCOPE.GROUP, description: '' },
  { text: locale('Third Party'), value: OPT_IN_SCOPE.THIRD_PARTY, description: '' },
];

const MULTI_OPT_IN_SCOPE = {
  BRAND:       'brand_opt_in_list',
  GROUP:       'group_opt_in_list',
  THIRD_PARTY: 'third_party_opt_in_list',
  CUSTOM:      'brand_opt_in_custom',
};

const MULTI_OPT_IN_SCOPE_ALL = _.values(MULTI_OPT_IN_SCOPE, 'value');

const MULTI_OPT_IN_SCOPE_LIST = [
  { text: locale('Brand'), value: MULTI_OPT_IN_SCOPE.BRAND, description: '' },
  { text: locale('Group'), value: MULTI_OPT_IN_SCOPE.GROUP, description: '' },
  { text: locale('Third Party'), value: MULTI_OPT_IN_SCOPE.THIRD_PARTY, description: '' },
  { text: locale('Custom'), value: MULTI_OPT_IN_SCOPE.CUSTOM, description: '' },
];

//object that shows that all marketing scopes are available
const AVAILABLE_DEFAULT_OPTIN_SCOPES = {
  [OPT_IN_SCOPE.BRAND]:       '',
  [OPT_IN_SCOPE.GROUP]:       '',
  [OPT_IN_SCOPE.THIRD_PARTY]: '',
};

export {
  OPT_IN_SCOPE,
  OPT_IN_SCOPE_LIST,
  OPT_IN_SCOPE_ALL,
  AVAILABLE_DEFAULT_OPTIN_SCOPES,
  MULTI_OPT_IN_SCOPE,
  MULTI_OPT_IN_SCOPE_LIST,
  MULTI_OPT_IN_SCOPE_ALL,
};

export default OPT_IN_SCOPE;
